

import React from 'react';
import { extend } from 'lodash';
import { Spin } from 'antd';

const DonateYourBillSection = (props) => {
  const { selectedBillsToDisplay, finalAmountOfSelectedBills, selectedBills, parentComponentType, loading, data, setBills } = props;
  return (
    <div>
      <section style={{ paddingBottom: '15px' }} className="donate-your-bills">
        <div className="container">
          {
            parentComponentType !== 'donateMoney' ?
            <h2 className="main-heading text-center mb-5">Donate your bills</h2> : ''
          }
          <Spin spinning={loading}>
            <div className="row no-gutters">
              {
                data && data.map(({ method, icon, name, final_amount: finalAmount }, index) => {
                  const divParams = { cursor: 'pointer' };
                  const isSelected = selectedBills.find((bill) => bill.method === method);
                  if (isSelected) {
                    extend(divParams, {
                      background: '#fffcdb'
                    })
                  }
                  return <div style={divParams} onClick={() => setBills({ method, name, finalAmount })} key={index} className="col-lg-3 col-md-4 col-sm-6 ">
                    <div className="bills_box">
                      <span className="top_border"></span><span className="bottom_border"></span><span className="right_border"></span>
                      <div className="icon-wrap">
                        <img style={{ width: 66, height: 65.979 }} src={`${process.env.REACT_APP_BACKEND_BASE_URL}/${icon}`} alt=''/>
                      </div>
                      <h3 style={{ color: isSelected ? '#3cb64f' : 'black' }}>{name || 'N/A'}</h3>
                    </div>
                  </div>
                })
              }
            </div>
          </Spin>
        </div>
        <div className="container total-bill-box">
          <div style={{ marginBottom: '5px' }} className="total">
            <div className="left_text">
              <h4>Total</h4>
              <p>
                <span className="font-weight-bold">Bills :</span>
                <span className=" ml-2">
                  {
                    selectedBillsToDisplay
                  }
                </span>
              </p>
            </div>
            <div className="right_text text-right">
              <p className="total-tag">Total donations</p>
              <h4 className="total-amount text_green">AU$ {finalAmountOfSelectedBills}</h4>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default DonateYourBillSection;
